export const FETCH_USER_PAYMENT = 'FETCH_USER_PAYMENT'
export const FETCH_USER_PAYMENT_SUCCESS = 'FETCH_USER_PAYMENT_SUCCESS'
export const FETCH_USER_PAYMENT_FAILURE = 'FETCH_USER_PAYMENT_FAILURE'
export const MAKE_FEE_PAYMENT = 'MAKE_FEE_PAYMENT'
export const UPDATE_RAZORPAY_STATUS = 'UPDATE_RAZORPAY_STATUS'
export const UPDATE_TAX_INFO = 'UPDATE_TAX_INFO'
